import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import ProfitStaticsHeadquarterTable from '../../components/profitresults_statics/ProfitStaticsHeadquarterTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import dayjs from 'dayjs'; // 날짜 처리를 위해 추가

const ProfitresultsStaticsHqContainer = ({
  type,
  selectedYear,
  strMonth,
  strDay, // 부모에서 넘겨주는 일자 추가
  endMonth,
  endDay,   // 부모에서 넘겨주는 일자 추가
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const onLoadData = async () => {
   
    setLoading(true);
    const searchParams = {
      startDt: `${selectedYear}-${strMonth}-${strDay}`,
      endDt: `${selectedYear}-${endMonth}-${endDay}`,
      target: 'teamAll',
    };

    try {
      const res = await staticsApi.getProfitStaticsByNew(
        selectPrjTyp,
        searchParams, // 변수명 중복 방지를 위해 searchParams로 변경
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    // searchData(문자열 키)가 변경될 때마다 데이터를 다시 불러옴
    if (searchData) {
      onLoadData();
    }
  }, [searchData]);

  const content = loading ? (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
      <CircularProgress />
    </Box>
  ) : (
    <ProfitStaticsHeadquarterTable
      data={data || []}
      loading={loading}
      tableRef={tableRef}
      selectPrjTyp={selectPrjTyp}
      // 테이블 내부 UI 표시용으로 전달
      strMonth={`${strMonth}`} 
      endMonth={`${endMonth}`}
    />
  );

  return content;
};

export default ProfitresultsStaticsHqContainer;
